import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ModalProvider } from './contexts/ModalContext';
import { AuthProvider } from './contexts/AuthContext';
import { DevicePreviewProvider } from './contexts/DevicePreviewContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Auth from './pages/Auth';
import NotFound from './pages/NotFound';
import Media from './pages/Media';
import SceneEditor from './pages/SceneEditor';
import StoryEditor from './pages/StoryEditor';
import StoryPreview from './pages/StoryPreview';
import Picker from './pages/Picker';
import Settings from './pages/Settings';
import ImageGenExtensions from './components/imagegen/ImageGenExtensions';
import ModalsContainer from './components/ModalsContainer';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ModalProvider>
          <DevicePreviewProvider>
            <Routes>
              <Route path="/auth" element={<Auth />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/folder/:folderId"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/media"
                element={
                  <ProtectedRoute>
                    <Media />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/media/folder/:folderId"
                element={
                  <ProtectedRoute>
                    <Media />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/scene/:sceneId"
                element={
                  <ProtectedRoute>
                    <SceneEditor />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/story/:storyId"
                element={
                  <ProtectedRoute>
                    <ImageGenExtensions>
                      <StoryEditor />
                    </ImageGenExtensions>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings/integrations"
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route path="/story-preview" element={<StoryPreview />} />
              <Route path="/picker" element={<Picker />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <ModalsContainer />
          </DevicePreviewProvider>
        </ModalProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
